var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('script',{ref:"script",attrs:{"name":_vm.name,"type":"text/plain"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }